//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { find, map } from "lodash";
import React, { useMemo, useRef, useState } from "react";
import styled from "styled-components";
//  -- Constants ----------------------
import { Switch ,Modal , Button } from '@mui/material';
import { useEffect } from 'react';
import { useDrag, useDragLayer, useDrop } from 'react-dnd';
import COLOR from "utils/constants/color";
import * as Sentry from '@sentry/react';
import { useAlert } from "components/UI/alertSakeBar/alertProvider";
import { filter } from "lodash";
//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------

const ImageItem = styled.img`
  height: 100px;
  width: 80px;
object-fit:cover;
`;

const Text = styled.div`
  font-size: 9px;
  line-height: 10px;
  color: white;
  white-space: pre-line;
`;

const TextContainer = styled.div`
  border-top: 1px solid ${COLOR.black800};
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  height: 30px;
  width:150px;
  padding:2px;
  background-color: #171e2d;
`;

const Wrapper = styled.button`
  background-color: transparent;
  border: none;
  border-radius: 3px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  cursor: pointer;
  height: auto;
  outline: none;
  transition: all 300ms ease;
  width: 100%;

`;

const ListItemCovers = styled.li`
  margin-top: 32px;
  margin-left: 10px;
  margin-right: 10px;
  box-shadow: ${(p) =>
    p.active ?" -3px 2px 8px 0px #00989d, 3px 1px 5px #00989d;" : p.preActive ? "-3px 2px 8px 0px #9d0001, 3px 1px 5px #9d0000;" : "none"};
`;
const List = styled.ul`
  height: auto;
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  list-style-type: none;
  justify-content: center;
  margin-top:24px;
`;
const CoverImage = styled.img`
    height: 200px;
    width: 150px;
    object-fit: cover;
`;
const OuterWrapper = styled.div``;
const ContainerSwitch = styled.div`
  display:flex;
  align-items:center;
  justify-content:center;
`;
const Labels = styled.div`
    color:black;
    font-weight:500;
    font-size:14px;
`;
const ModalContent = styled.div`
    align-items: center;
    background-color: ${COLOR.white};
    border-radius: 3px;
    display: inline-flex;
    flex-direction: column;
    left: 50%;
    max-width: 320px;
    padding: 16px;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
`;
const ModalRow = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 16px;
    width: 100%;
`;
export const BookSignleList = ({ data, selected, onSelect,orderedBook,searchText ="" }) => {
  const [bookid, setBookid] = useState([]);
  const [otherGroupSelected, setotherGroupSelected] = useState([]);
  const isActive = React.useCallback((id) => { return bookid.includes(id) })
  const sortedItems = [...data.filter((book) => selected.includes(book.id)), ...data.filter((book) => !selected.includes(book.id))];
  const [askAlert,setAskAlert] = useState(false);
  const [selectedData,setSelectedData] = useState(null);
  const findBookId = (id,orderedBook) => {
    let found = false
    orderedBook.forEach((book) => {
      book.books.forEach((book) => {
        if(book.id == id){
          found = true
        }
      })
    })
    return found
  }

  const fitleredData = useMemo(() => {
    if(searchText?.length > 0){
        return filter(sortedItems, (item) => item?.description?.toLowerCase().includes(searchText?.toLowerCase()))
    }else{
        return sortedItems;
    }
}, [searchText,sortedItems])
 
  const handleSelectArea = (data, allow) => {
    let bids = Array.from(bookid);
    const hasBook = bookid.includes(data?.id);
    if (!allow &&!hasBook && (!selected.includes(data.id) && findBookId(data.id, orderedBook))) {
      setSelectedData(data)
      setAskAlert(true)
      return
    }
    if (hasBook) {
      bids = bids.filter((i) => data.id !== i);
    } else {
      bids.push(data?.id)
    }
    onSelect(bids);
    setBookid(bids);
    setSelectedData(null)
  }
  useEffect(() => {
    try {
      if (selected && selected.length > 0 && bookid.length == 0) {
        setBookid(selected);
      }
    } catch (error) {
      Sentry.captureException(`436 Error during useEffect: ${error}`);
    }
  }, [selected]);

  return (
    <List>
        <Modal
                open={askAlert}
                onClose={() => setAskAlert(false)}
            >
                <ModalContent>
                This book is already assigned to another group. Are you sure you want to add it to this group?
                    <ModalRow>
                        <Button
                            style={{ marginRight: '4px' }}
                            onClick={() => {
                              setAskAlert(false)
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            style={{ marginRight: '4px' }}
                            color="secondary"
                            variant="contained"
                            onClick={() => {
                              handleSelectArea(selectedData, true)
                              setAskAlert(false)
                            }}
                        >
                           Yes
                        </Button>
                    </ModalRow>
                </ModalContent>
            </Modal>
      {map(fitleredData, book => {
        if (!book || !book.id) return null;
        const activeStatus = isActive(book.id);
        const preactive = otherGroupSelected?.includes(book.id);
        
        return (
          <ListItemCovers key={book.id}
            active={activeStatus}
             preActive={preactive}
            onClick={(e) => {
              e.preventDefault();
              handleSelectArea(book)
            }}
          >
            <Wrapper>
              <div className="card-resource">
                <a >
                  <div className="card-resource-overlay" style={{ opacity: 0 }}></div>
                  <ImageItem
                    className="card-resource-image"
                    src={book.img}
                    alt={book.description}
                  />
                  <TextContainer>
                    <Text>{book.description}</Text>
                  </TextContainer>
                </a>
              </div>
            </Wrapper>
          </ListItemCovers>
        )
      })}
    </List>
  )
}

const ItemType = 'CARD';

const layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
};

function getItemStyles(initialOffset, currentOffset) {
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none',
    };
  }

  const { x, y } = currentOffset;
  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    WebkitTransform: transform,
    opacity: 0.9, // Set desired opacity here
    maxWidth: 400
  };
}

const BookCovers = ({ book, hasPrintToogle, printable, onPrintOptionChange }) => {
  const showAlert = useAlert();
  const isPagePrintable = book?.pages?.some(page => page?.printable) || book?.printable;
  return (<>
    {hasPrintToogle ? <ContainerSwitch>
      <Labels>Printable</Labels>
      <Switch checked={isPagePrintable ? printable : false} onChange={(e) => {
        if (!isPagePrintable) {
          showAlert("This book is not printable. Please enable the print option in the book settings.", "error");
          return;
        }
        onPrintOptionChange(book.id, e.target.checked)
      }} 
      />
    </ContainerSwitch> : null}
    <div className="card-resource">
      <a href={`/add-book?bookId=${book.id}`}>
        <div className="card-resource-overlay" style={{ opacity: 0 }}></div>
        <CoverImage
          className="card-resource-image"
          src={book.img}
          alt={book.description}
        />
        <TextContainer>
          <Text>{book.description}</Text>
        </TextContainer>
      </a>
    </div>
  </>)
}

const CustomDragLayer = ({ all_items }) => {
  const {
    itemType,
    isDragging,
    item,
    initialOffset,
    currentOffset,
  } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }));
  const item_data = useMemo(() => find(all_items, ['id', item?.id]) || item, [all_items, item])
  if (!isDragging) {
    return null;
  }

  return (
    <div style={layerStyles}>
      <div style={getItemStyles(initialOffset, currentOffset)}>
        <BookCovers key={item_data.id} book={item_data} />
      </div>
    </div>
  );
};
  
const DraggableCard = ({ item, index, moveCard, setDragOverIndex, disabled  , onPrintOptionChange , hasPrintToogle , printable }) => {
  const ref = useRef(null);

  const [, drop] = useDrop({
    accept: ItemType,
    hover: (draggedItem, monitor) => {
      if (!ref.current || disabled) {
        return;
      }
      const dragIndex = draggedItem.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      const hoverBoundingRect = ref.current.getBoundingClientRect();
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }

      moveCard(dragIndex, hoverIndex);
      draggedItem.index = hoverIndex;
    },
    drop: (draggedItem) => {
      moveCard(draggedItem.index, index);
    },
  });

  const [{ isDragging }, drag, preview] = useDrag({
    type: ItemType,
    item: { id: item.id, index },
    canDrag: !disabled,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(ref));
  useEffect(() => {
    const emptyImage = new Image();
    emptyImage.src = '';
    emptyImage.style.opacity = 0;
    preview(emptyImage);
  }, [preview])
  return (
    <OuterWrapper ref={ref} style={{ opacity: 1 }}>
      <BookCovers key={item.id} book={item}  hasPrintToogle={hasPrintToogle}  printable={printable}  onPrintOptionChange={onPrintOptionChange} />
    </OuterWrapper>
  );
};


const OrderBookGroup = ({ chapter, disabled, onRearrangeDone , hasPrintToogle ,onPrintOptionChange , print_permissions }) => {
  const [books, setBooks] = useState([])
  useEffect(() => {
    setBooks(chapter)
  }, [chapter])
  //  -- Handlers ---------------------
  const moveBook = (dragIndex, hoverIndex) => {
    const newChapter = [...books];
    const draggedBook = newChapter[dragIndex];
    newChapter.splice(dragIndex, 1);
    newChapter.splice(hoverIndex, 0, draggedBook);
    setBooks(newChapter)
    onRearrangeDone(newChapter);
  };

  return (
    <>
      <div style={{ display: "flex", gap: 12, marginTop: 24, overflow: "auto" }}>
        {map(books, (book, index) => {
          
          if (!book?.active) {
            return null;
          }
          return (
            <DraggableCard
              key={book.id}
              id={book.id}
              item={book}
              index={index}
              moveCard={moveBook}
              disabled={disabled}
              hasPrintToogle={print_permissions && hasPrintToogle}
              onPrintOptionChange={onPrintOptionChange}
              printable={print_permissions ? print_permissions[book.id] : false}
            />
          );
        })}
      </div>
      <CustomDragLayer all_items={books} />
    </>
  );
};

export default OrderBookGroup;
